/* eslint-disable no-template-curly-in-string */

import { RadioCard, Tags, Typography } from 'components'
import { TypographyTypes } from 'interfaces'
import { typeTagOption } from 'lib'
import React from 'react'
import { StepOneProps } from './step.type'

export const StepOne: React.FC<StepOneProps> = props => {
	const {
		selectedTagOption,
		steps,
		initialStateTotalList,
		dataTags,
		isLoadingTags,
		totalList,
		isFetchingNextPageTags,
		handleChangeDebounceTags,
		resetInputTags,
		fetchNextPageTags,
		setSelectedTagOption,
		setTotalList
	} = props

	return (
		<div className="flex flex-col justify-start w-full items-start gap-4">
			<Typography
				title={
					selectedTagOption.value === 'organization_tag'
						? 'Select tags for these users '
						: steps
				}
				fontLeading="14/24"
				type={TypographyTypes.h1}
				className="text-black font-medium text-lg"
			/>
			<Typography
				title={
					selectedTagOption.value === 'organization_tag'
						? 'You can apply tags from the CSV file or choose existing organization tags for all imported users.'
						: 'You can use tags from the CSV file or select existing organization tags to update current users or assign tags to new users.'
				}
				fontLeading="14/24"
				type={TypographyTypes.p}
				className="text-black font-normal text-base"
			/>

			<div className="w-full">
				<div className="flex flex-col gap-4 w-full">
					<RadioCard
						title="Apply organization's tags"
						description="So all users in your populated spreadsheet template are assigned the same tag or tags."
						checked={selectedTagOption.value === 'organization_tag'}
						onChange={() => {
							const orgTagOption = typeTagOption.find(
								opt => opt.value === 'organization_tag'
							)
							if (orgTagOption) {
								setSelectedTagOption(orgTagOption)
							}
						}}
						id="radio-org-tags"
					/>

					<RadioCard
						title="Use CSV's tags"
						description="For users who require individual tags, make sure the tag field is correctly filled out in the spreadsheet template."
						checked={selectedTagOption.value === 'csv_tag'}
						onChange={() => {
							const csvTagOption = typeTagOption.find(
								opt => opt.value === 'csv_tag'
							)
							if (csvTagOption) {
								setSelectedTagOption(csvTagOption)
								setTotalList(initialStateTotalList)
							}
						}}
						id="radio-csv-tags"
					/>
				</div>
			</div>

			{selectedTagOption.value === 'organization_tag' && (
				<div className="w-full h-[16.6rem] border-[1px] border-solid border-blue-primary rounded-lg px-4 pb-4 pt-2">
					<Typography
						title="Select tags for all users in this CSV:"
						fontLeading="14/24"
						type={TypographyTypes.p}
						className="text-black font-normal text-base pb-1"
					/>

					<div className="h-[90%] w-full overflow-y-auto px-4">
						<Tags
							data={dataTags}
							isLoading={isLoadingTags}
							totalList={totalList}
							resetInput={resetInputTags}
							setTotalList={setTotalList}
							fetchNextPage={fetchNextPageTags}
							isFetchingNextPage={isFetchingNextPageTags}
							handleChangeDebounce={handleChangeDebounceTags}
							activeSearch={false}
							reachView={false}
							seeTagRequired
							fullHeight
						/>
					</div>
				</div>
			)}
		</div>
	)
}
